import {useContext, useEffect, useState} from "react";
import {getUsers} from "../api/api";
import editIcon from "../../img/edit.svg";
import deleteIcon from "../../img/delete.svg";
import arrowdown from "../../img/arrwodown.png";
import arrowup from "../../img/arrowup.png";
import {useNavigate} from "react-router-dom";
import {APIContext} from "../Globals.tsx";
import moment from "moment";
import {getRemainingTickets} from "../ToDos";

function sortTable(gt, col = 0, id){
  var table, rows, switching, i, x, y, shouldSwitch;
  table = document.getElementById(id);
  switching = true;
  /*Make a loop that will continue until
  no switching has been done:*/
  while(switching){
    //start by saying: no switching is done:
    switching = false;
    rows = table.rows;
    /*Loop through all table rows (except the
    first, which contains table headers):*/
    for(i = 1; i < (rows.length - 1); i++){
      //start by saying there should be no switching:
      shouldSwitch = false;
      /*Get the two elements you want to compare,
      one from current row and one from the next:*/
      x = rows[i].getElementsByTagName("TD")[col];
      y = rows[i + 1].getElementsByTagName("TD")[col];
      //check if the two rows should switch place:
      if(gt){
        if(col === 4){
          //special treat col
          let date1 = moment(x.innerHTML.split("-")[1], "D.M.YYYY");
          let date2 = moment(y.innerHTML.split("-")[1], "D.M.YYYY");
          if(!date1.isValid()){
            date1 = new Date("1970-01-01");
          }
          if(!date2.isValid()){
            date2 = new Date("1970-01-01");
          }
          if(new Date(date1) > new Date(date2)){
            shouldSwitch = true;
            break;
          }
        }
        else if(x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()){
          //if so, mark as a switch and break the loop:
          shouldSwitch = true;
          break;
        }
      }
      else{
        if(col === 4){
          //special treat col 4
          let date1 = moment(x.innerHTML.split("-")[1], "D.M.YYYY");
          let date2 = moment(y.innerHTML.split("-")[1], "D.M.YYYY");
          if(!date1.isValid()){
            date1 = new Date("1970-01-01");
          }
          if(!date2.isValid()){
            date2 = new Date("1970-01-01");
          }
          if(new Date(date1) < new Date(date2)){
            shouldSwitch = true;
            break;
          }
        }
        else if(x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()){
          //if so, mark as a switch and break the loop:
          shouldSwitch = true;
          break;
        }
      }
    }
    if(shouldSwitch){
      /*If a switch has been marked, make the switch
      and mark that a switch has been done:*/
      rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
      switching = true;
    }
  }
}

function tableHeader(id){
  return <tr>
    <th>
      <div className={"grid gridtwo"}> Vorname
        <div className={"grid gridtworows"}>
          <img src={arrowup} className="dreieck" onClick={() => sortTable(true, 0, id)}
               alt={"arrow up"}></img>
          <img src={arrowdown} className="dreieck" onClick={() => sortTable(false, 0, id)}
               alt={"arrow down"}></img>
        </div>
      </div>
    </th>
    <th>
      <div className={"grid gridtwo"}> Nachname
        <div className={"grid gridtworows"}>
          <img src={arrowup} className="dreieck" onClick={() => sortTable(true, 1, id)}
               alt={"arrow up"}></img>
          <img src={arrowdown} className="dreieck" onClick={() => sortTable(false, 1, id)}
               alt={"arrow down"}></img>
        </div>
      </div>
    </th>
    <th>
      <div className={"grid gridtwo"}> Vertrag
        <div className={"grid gridtworows"}>
          <img src={arrowup} className="dreieck" onClick={() => sortTable(true, 2, id)}
               alt={"arrow up"}></img>
          <img src={arrowdown} className="dreieck" onClick={() => sortTable(false, 2, id)}
               alt={"arrow down"}></img>
        </div>
      </div>
    </th>
    <th>
      <div className={"grid gridtwo none-mobile-tile"}> E-Mail
        <div className={"grid gridtworows"}>
          <img src={arrowup} className="dreieck" onClick={() => sortTable(true, 3, id)}
               alt={"arrow up"}></img>
          <img src={arrowdown} className="dreieck" onClick={() => sortTable(false, 3, id)}
               alt={"arrow down"}></img>
        </div>
      </div>
    </th>
    <th>
      <div className={"grid gridtwo none-mobile-tile"}> Letzter besuchter Kurs
        <div className={"grid gridtworows"}>
          <img src={arrowup} className="dreieck" onClick={() => sortTable(true, 4, id)}
               alt={"arrow up"}></img>
          <img src={arrowdown} className="dreieck" onClick={() => sortTable(false, 4, id)}
               alt={"arrow down"}></img>
        </div>
      </div>
    </th>
    <th>
      <div className={"grid gridtwo none-mobile-tile"}>Kurse besucht
        <div className={"grid gridtworows"}>
        </div>
      </div>
    </th>
    <th></th>
  </tr>;
}

// TODO: split user and users correct!
export default function Users(){
  const [users, setUsers] = useState(null);
  const [ego, setEgo] = useState(null);
  const [contracts, setContracts] = useState(null);
  const navigate = useNavigate();
  const {getEgo, deleteUser, getContracts} = useContext(APIContext);

  useEffect(() => {
    getUsers().then(r => setUsers(r.persons.map(person => {
      person.courses = person.courses.sort((a, b) => new Date(b.startDate) - new Date(a.startDate));
      return person;
    })));
    getEgo().then(r => setEgo(r));

    getContracts(false).then(r => {
        let contracts_ = r?.contracts;
        contracts_ = contracts_.map(contract => {
          let value = !contract.repeat.includes("all_in") ? contract.repeat + "_" + contract.tickets : contract.repeat;
          return {...contract, value};
        });
        setContracts(contracts_);
      }
    );
  }, []);

  return (
    <div>
      <button
        className={"primarybutton"}
        onClick={() => navigate("/user/add")}
      >
        Neues Mitglied
      </button>
      <table id="usersTable">
        <tbody>
        {tableHeader("usersTable")}
        {users?.filter(user => user.authLevel >= 0)?.map((user) =>
          <tr key={user.id}>
            <td onClick={() => navigate("/user/" + user.id)}>{user.firstname}</td>
            <td onClick={() => navigate("/user/" + user.id)}>{user.lastname}</td>
            <td
              onClick={() => navigate("/user/" + user.id)}>{(contracts?.find(type => type.value === user.contract?.repeat) ?? {}).name}{user.ticketsMax > 0 ? "   " + ((user.tickets === getRemainingTickets(user, new Date()) ? user.tickets : "not sure") + "/" + user.ticketsMax) : ""}</td>
            <td onClick={() => navigate("/user/" + user.id)}
                className={"none-mobile-tile"}>{user.email}</td>
            <td onClick={() => navigate("/user/" + user.id)}
                className={"none-mobile-tile"}>{user.courses?.length ? (user.courses[0].type + " - " + new Date(user.courses[0].startDate).toLocaleDateString('de-DE')) : ""}</td>
            <td onClick={() => navigate("/user/" + user.id)}
                className={"none-mobile-tile"}>{user.courses?.length}</td>
            <td><img className={"icon none-mobile-tile"} src={editIcon}
                     onClick={() => navigate("/user/" + user.id + "?edit=true")} alt={"edit"}/></td>
            <td><img className={"icon none-mobile-tile red"} src={deleteIcon} onClick={() => {
              deleteUser(user.id).then(() =>
                window.location.reload()
              );
            }} hidden={ego?.id === user.id} alt={"delete"}/>
            </td>
          </tr>)
        }
        </tbody>
      </table>
      {users?.filter(user => user.authLevel < 0)?.length > 0 && <div style={{marginTop: 100}}>
        <h1>Gäste</h1>
        <table id="usersTable1">
          <tbody>
          {tableHeader("usersTable1")}
          {users?.filter(user => user.authLevel < 0)?.map((user) =>
            <tr key={user.id}>
              <td onClick={() => navigate("/user/" + user.id)}>{user.firstname}</td>
              <td onClick={() => navigate("/user/" + user.id)}>{user.lastname}</td>
              <td onClick={() => navigate("/user/" + user.id)}>{user.contract?.repeat}</td>
              <td onClick={() => navigate("/user/" + user.id)}
                  className={"none-mobile-tile"}>{user.email}</td>
              <td onClick={() => navigate("/user/" + user.id)}
                  className={"none-mobile-tile"}>{user.courses?.length ? (user.courses[0].type + " - " + new Date(user.courses[0].startDate).toLocaleDateString('de-DE')) : ""}</td>
              <td onClick={() => navigate("/user/" + user.id)}
                  className={"none-mobile-tile"}>{user.courses?.length}</td>
              <td><img className={"icon none-mobile-tile"} src={editIcon}
                       onClick={() => navigate("/user/" + user.id + "?edit=true")} alt={"edit"}/></td>
              <td><img className={"icon none-mobile-tile red"} src={deleteIcon} onClick={() => {
                deleteUser(user.id).then(() =>
                  window.location.reload()
                );
              }} hidden={ego?.id === user.id} alt={"delete"}/>
              </td>
            </tr>)
          }
          </tbody>
        </table>
      </div>}
    </div>
  );
}